import * as React from 'react'

function LockedIcon(props) {
  return (
    <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.3335 8.66671C3.3335 8.31309 3.47397 7.97395 3.72402 7.7239C3.97407 7.47385 4.31321 7.33337 4.66683 7.33337H11.3335C11.6871 7.33337 12.0263 7.47385 12.2763 7.7239C12.5264 7.97395 12.6668 8.31309 12.6668 8.66671V12.6667C12.6668 13.0203 12.5264 13.3595 12.2763 13.6095C12.0263 13.8596 11.6871 14 11.3335 14H4.66683C4.31321 14 3.97407 13.8596 3.72402 13.6095C3.47397 13.3595 3.3335 13.0203 3.3335 12.6667V8.66671Z'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.3335 10.6667C7.3335 10.8435 7.40373 11.013 7.52876 11.1381C7.65378 11.2631 7.82335 11.3333 8.00016 11.3333C8.17697 11.3333 8.34654 11.2631 8.47157 11.1381C8.59659 11.013 8.66683 10.8435 8.66683 10.6667C8.66683 10.4899 8.59659 10.3203 8.47157 10.1953C8.34654 10.0702 8.17697 10 8.00016 10C7.82335 10 7.65378 10.0702 7.52876 10.1953C7.40373 10.3203 7.3335 10.4899 7.3335 10.6667Z'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.3335 7.33333V4.66667C5.3335 3.95942 5.61445 3.28115 6.11454 2.78105C6.61464 2.28095 7.29292 2 8.00016 2C8.70741 2 9.38568 2.28095 9.88578 2.78105C10.3859 3.28115 10.6668 3.95942 10.6668 4.66667V7.33333'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default LockedIcon
